import system from "./system";

const components = {
  button: {
    fontFamily: system.fonts.heading,
    fontSize: "18px",
    border: "2px solid #13433a",
    color: "#13433a",
  },
  divider: {
    backgroundColor: "rgba(19, 67, 58, 0.2)",
  },
  pageHeader: {
    fontFamily: system.fonts.title,
    color: system.colors.accent.red,
    fontSize: "48px",
    fontWeight: "bold",
    textShadow:
      "0px 0px 10px white, 0px 0px 10px white, 0px 0px 10px white",
  },
  sectionHeader: {
    fontFamily: system.fonts.title,
    fontSize: "48px",
    lineHeight: "60px",
    fontWeight: 400,
    color: system.colors.accent.red,
    textAlign: "center",
    textShadow: "0px 0px 10px #FFFFFF, 0px 0px 10px #FFFFFF, 0px 0px 10px #FFFFFF",
    WebkitTextStroke: "1px #FFFFFF",
    paintOrder: "stroke fill",
  },
  loading: {
    color: system.colors.text.primary,
  },
  footer: {
    color: system.colors.text.primary,
    fontFamily: system.fonts.body,
    fontSize: "16px",
    fontWeight: "bold",
  },
  howToUseSlider: {
    paper: {
      border: `1px solid ${system.colors.text.primary}`,
      borderRadius: 2,
      backgroundColor: system.colors.background.card,
    },
    overlay: {
      borderRadius: 1,
      backgroundColor: "rgba(19, 67, 58, 0.05)",
    },
    bullet: {
      active: "#13433a",
      inactive: "rgba(19, 67, 58, 0.3)",
    },
    text: {
      point: {
        fontFamily: system.fonts.heading,
        fontSize: "16px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      title: {
        fontFamily: system.fonts.heading,
        fontSize: "19px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "15px",
        color: system.colors.text.primary,
      },
    },
  },
  newsItem: {
    text: {
      title: {
        fontFamily: system.fonts.body,
        color: system.colors.text.primary,
        fontSize: "14px",
      },
      date: {
        fontFamily: system.fonts.body,
        color: system.colors.text.secondary,
        fontSize: "12px",
      },
    },
  },
  myPageCard: {
    paper: {
      backgroundColor: system.colors.background.card,
      border: "none",
      boxShadow: "0px 0px 10px 1px rgba(19, 67, 58, 0.2)",
    },
    text: {
      name: {
        fontFamily: system.fonts.heading,
        fontSize: "18px",
        fontWeight: 700,
        color: system.colors.text.primary,
      },
      remainingDays: {
        fontFamily: system.fonts.body,
        fontSize: "12px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "15px",
        color: system.colors.text.primary,
      },
    },
  },
  questCard: {
    paper: {
      backgroundColor: "rgba(217, 217, 217, 0)",
      border: "1px solid #13433a",
      boxShadow: "0px 0px 10px 1px white",
    },
    text: {
      name: {
        fontFamily: system.fonts.heading,
        fontSize: "16px",
        color: system.colors.text.primary,
        fontWeight: 700,
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "12px",
        color: system.colors.text.primary,
      },
    },
    lockIcon: {
      color: "#13433a",
    },
    chip: {
      cleared: {
        backgroundColor: system.colors.accent.green,
        border: "1px solid " + system.colors.accent.green,
        borderRadius: "20px",
        boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
        fontFamily: system.fonts.heading,
        color: "#ffffff",
        fontWeight: 700,
        fontSize: "11px",
      },
      uncleared: {
        backgroundColor: "transparent",
        border: "1px solid #13433a",
        borderRadius: "20px",
        boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
        fontFamily: system.fonts.heading,
        color: system.colors.text.primary,
        fontWeight: 700,
        fontSize: "11px",
      },
    },
  },
  ticketBox: {
    text: {
      name: {
        fontFamily: system.fonts.heading,
        fontSize: "22px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "14px",
        color: system.colors.text.primary,
      },
      price: {
        fontFamily: system.fonts.heading,
        fontSize: "22px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      notice: {
        fontFamily: system.fonts.body,
        fontSize: "13px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
    },
  },
  questRewardBox: {
    paper: {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      borderRadius: "4px",
    },
    lockIcon: {
      color: "#13433a",
    },
  },
  storySection: {
    name: {
      fontFamily: system.fonts.body,
      fontSize: "14px",
      fontWeight: "bold",
      color: system.colors.text.primary,
      WebkitTextStroke: "4px #FFFFFF",
      paintOrder: "stroke fill",
    },
    story: {
      fontFamily: system.fonts.body,
      fontSize: "18px",
      color: system.colors.text.primary,
      lineHeight: "1.8",
      WebkitTextStroke: "1px #FFFFFF",
      paintOrder: "stroke fill",
    },
    storyKaede: {
      fontFamily: '"Noto Sans JP", sans-serif',
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "30px",
      letterSpacing: "0.1em",
      color: system.colors.text.primary,
      WebkitTextStroke: "3.5px #FFFFFF",
      paintOrder: "stroke fill",
    },
  },

  dialog: {
    title: {
      fontFamily: system.fonts.heading,
      fontSize: "16px",
      color: system.colors.text.primary,
    },
    description: {
      fontFamily: system.fonts.body,
      fontSize: "14px",
      color: system.colors.text.primary,
    },
    width: "80%",
    backgroundColor: system.colors.background.dialog,
    button: {
      color: system.colors.text.primary,
    },
  },
};

export default components;
